import { combineReducers } from 'redux'
import keycloak from './keycloak';
import language from './language'
import backgroundRunning from './backgroundRunning'
import contextInfo from './contextInfo'
import lobby from './lobby'
import popup from './popup'

const rootReducer = combineReducers({
    keycloak,
    language,
    backgroundRunning,
    contextInfo,
    lobby,
    popup
})

export default rootReducer